module.exports = __webpack_public_path__ + "img/03.ae223533.jpg";